import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',

    '& label': {
      marginLeft: 3
    }
  },

  avatar: {
    border: '2px solid white',
    width: '30px',
    height: '30px',
    fontSize: theme.size.sm
  }
}))

export default useStyles
